export default __webpack_public_path__ + "static/media/personality_ESTj.bb0ab651.png";